import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/antd.css';
import './styles/antd-override.css';
import App from '../src/components/app'
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux"
import configureStore from '../src/redux/configureStore';
import { ThemeProvider, jssPreset } from "@material-ui/core/styles"
import CustomTheme from '../src/assets/custom_theme'
import CssBaseline from '@material-ui/core/CssBaseline'
import { create } from "jss"
import rtl from "jss-rtl"
import { StylesProvider } from '@material-ui/core'
const store = configureStore()
const jss = create({ plugins: [...jssPreset().plugins, rtl()] })
const lang = localStorage.getItem("lang")

const root = ReactDOM.createRoot(document.getElementById('root'));
document.getElementsByTagName('html')[0].setAttribute("dir", (lang && (lang === 'fa')) ? 'rtl' : 'ltr');
if(!lang||lang==='en')
document.title='Multiscanner - Cyberno'
else
document.title='پویشگر چندموتوره - سایبرنو'

root.render(
  <Provider store={store}>
    <ThemeProvider theme={CustomTheme}>
      <StylesProvider jss={jss}>
        <CssBaseline />
        <App />
      </StylesProvider>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
